<template>
    <div class="row justify-content-center">
        <div class="col-md-9">
            <div class="d-flex flex-column align-items-center">
                <a v-if="!active" class="btn btn-secondary mb-4 login-btn" :href="samlLogin">
                    Login With AAA
                </a>

                <a v-if="!active" class="btn btn-primary login-btn" @click="active = true" href="javascript:void(0)">
                    I Have a Guest Account
                </a>
            </div>
            <transition name="fade">
                <form v-if="active" @submit.prevent="submit">
                    <div class="form-group">
                        <FormLabel required for="email">E-Mail Address</FormLabel>
                        <FormInput id="email" type="email" :class="{'is-invalid': validationErrors.email}" v-model="form.email" autofocus/>
                        <ValidationError v-if="validationErrors.email">{{ validationErrors.email }}</ValidationError>
                    </div>
                    <div class="form-group">
                        <FormLabel required for="password">Password</FormLabel>
                        <FormInput id="password" type="password" :class="{'is-invalid': validationErrors.password}" v-model="form.password"/>
                        <ValidationError v-if="validationErrors.password">{{ validationErrors.password }}</ValidationError>
                    </div>
                    <div class="form-group d-flex flex-column flex-md-row-reverse justify-content-between align-items-center">
                        <a class="mb-3 mb-md-0" href="/password/reset">Forgot Password?</a>
                        <FormButton type="submit" :pending="pending" pendingText="Authenticating">Login</FormButton>
                    </div>
                </form>
            </transition>
        </div>
    </div>
</template>

<script>
import FormInput from '@/components/form/FormInput';
import FormLabel from '@/components/form/FormLabel';
import FormCheckbox from '@/components/form/FormCheckbox';
import FormButton from '@/components/form/FormButton';
import AuthService from '@/services/auth.service';
import FormMixin from '@/mixins/FormMixin';
import eventBus from '@/event-bus';

export default {
    components: {
        FormButton,
        FormCheckbox,
        FormLabel,
        FormInput
    },
    props: {
        csrf: {
            type: String,
            required: true
        },
        action: {
            type: String,
            required: true
        },
        samlLogin: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            form: {
                email: '',
                password: ''
            },
            active: false
        }
    },
    mixins: [
        FormMixin
    ],
    methods: {
        async submit() {
            this.pending = true;
            this.errorMessage = '';
            this.validationErrors = {};
            this.errorStatusCode = null;

            try {
                const response = await AuthService.login(this.form);

                window.location = response.redirect;

                this.success = true;
            } catch (error) {
                this.handleError(error);

                eventBus.$emit('notification', {
                    type: 'error',
                    message: this.errorMessage
                });

                this.pending = false;
            }
        }
    }
}
</script>
